module.exports = __webpack_public_path__ + "img/yimane.73ac19e9.svg";